<template>

    <v-card>
        <v-card-title>
          <v-toolbar color="indigo darken-1" dark> 
            Utrošak materijala
            <v-spacer></v-spacer>                            
            <v-btn class="mx-2" fab dark color="indigo" @click='newMaterial'>
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, 50]
            }"
            :items-per-page="10"
            item-key="id"
            @click:row="navigateTo"
          >
          <template v-slot:[`item.itemSuppPrice`]="{ item }">
              <span>{{ localMoney(item.itemSuppPrice) }}</span>
          </template>
          <template v-slot:[`item.itemPcsMinus`]="{ item }">
              <span>{{ localMoney(item.itemPcsMinus) }}</span>
          </template>
          <template v-slot:[`item.itemBaseAmount`]="{ item }">
              <span>{{ localMoney(item.itemBaseAmount) }}</span>
          </template>
          <template slot="pageText" slot-scope="{ pageStart, pageStop }">
            From {{ pageStart }} to {{ pageStop }}
          </template>
        </v-data-table>
      </v-card>

</template>

<script>
// import axios from 'axios'
import moneyFormat from '@/snippets/moneyFormat'

export default {
  name: 'documentdetaillist3',
  data () {
    return {
      msg: '',
      items: [],
      max25chars: (v) => v.length <= 25 || 'Input too long!',
      tmp: '',
      search: '',
      pagination: {},
      rowsPerPageItems: [50],
      headers: [ ],
      mainQuery: {
        CompanyId: 1,
        businessYear: 0,
        documentName: '',
        databaseDocID: 0,
        FreeF1: 1
      }
    }
  },
  async mounted () {
    try {
      if (this.$store.state.companyid) {
        this.mainQuery.CompanyId = this.$store.state.companyid
      }
      if (this.$store.state.businessYear) {
        this.mainQuery.businessYear = this.$store.state.businessYear
      }
      if (this.$store.state.documentActiv) {
        this.mainQuery.documentName = this.$store.state.documentActiv
      }
      if (this.$store.state.databaseDocID) {
        this.mainQuery.databaseDocID = this.$store.state.databaseDocID
      }
      this.mainQuery.FreeF1 = 1
      this.items = this.$store.state.documentActivItems.filter(item => {
            return parseInt(item.FreeF6)  === 3
          })
 
      if (this.$store.state.language === 'EN') {
        this.headers.push(
          {
            text: 'item Name',
            align: 'left',
            sortable: true,
            value: 'itemName'
          },
          { text: 'Unit', align: 'left', value: 'itemUnit' },
          { text: 'Supp.Price ', align: 'left', value: 'itemSuppBasePrice' },
          { text: 'Pcs', align: 'left', value: 'itemPcsMinus' },
          { text: 'Supp.Amount', align: 'right', sortable: true, value: 'itemBaseAmount' },
          { text: 'DbId', value: 'id' }
       )
      }
      if (this.$store.state.language === 'HR') {
        // console.log(' radim push 2 hr naziva ', this.$store.state.language)
        this.headers.push(
          {
            text: 'Artikl/usluga',
            align: 'left',
            sortable: true,
            value: 'itemName'
          },
          { text: 'Jmj', align: 'left', value: 'itemUnit' },
          { text: 'Dob.cij.(4 decimale)', align: 'left', value: 'itemSuppBasePrice' },
          { text: 'Količina', align: 'left', value: 'itemPcsMinus' },
          { text: 'Dob.iznos', align: 'right', sortable: true, value: 'itemBaseAmount' },
          { text: 'Id baze', value: 'id' }
        )
      }
    } catch (error) {
      // eslint-disable-next-line
      console.log(error)
    }
  },
  methods: {
    localMoney(moneyToFormat) {
      return moneyFormat(moneyToFormat)
    },
    navigateTo (item) {
      this.$store.dispatch('seteditItem', 1)
      this.$store.dispatch('setDocumentDetailid',item.id)
      this.$store.dispatch('settypePOS', 3)
      // warehouse minus
      this.$store.dispatch('setDocumentSide', 2) 
      this.$router.push({
        name: 'documentdetailcreateedit3'
      })
    },
    newMaterial () {
      this.$store.dispatch('seteditItem', 0)
      this.$store.dispatch('settypePOS', 3)
      // warehouse minus
      this.$store.dispatch('setDocumentSide', 2) 
      this.$router.push({
        name: 'documentdetailcreateedit3'
      })
    }
  },
  computed: {

  },
  watch: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
